import ClosableModal from '../closableModal/closableModal';

interface ProfileModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  targetRef?: React.RefObject<HTMLDivElement | null>;
  resizable?: boolean;
}

const ProfileModal: React.FC<ProfileModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  resizable = false,
}) => (
  <ClosableModal
    open={isOpen}
    onClose={onClose}
    title={title}
    className="profile-modal"
    data-testid="profile-modal"
    resizable={resizable}
  >
    <div className="popover-body resizable-modal-fill">{children}</div>
  </ClosableModal>
);

export default ProfileModal;
